import _ from "lodash";
import React, { useEffect, useState } from "react";
import { onEnterOrSpaceKeyDown } from "Utils/AccessibilityHelpers";

import { IconButton } from "@toddle-edu/ds-web";
import { ChevronDownOutlined, ChevronUpOutlined } from "@toddle-edu/ds-icons";

import { AlertCard } from "AppComponents/StudentAlerts/components";
import { getStudentAlertTypeIcon } from "StudentAlertsSettings/modules/StudentAlertsSettingsUtils";

import classes from "./StudentAlertsSection.scss";

const StudentAlertsSection = props => {
  const { alerts } = props;
  const [openAlerts, setOpenAlerts] = useState([]);

  useEffect(() => {
    if (_.size(alerts) === 1) {
      setOpenAlerts([alerts[0].id]);
    }
  }, [alerts]);

  const getToggleAlertTypeHandler = id => () => {
    setOpenAlerts(prevOpenAlertTypes => {
      if (_.includes(prevOpenAlertTypes, id)) {
        return _.filter(prevOpenAlertTypes, openId => openId !== id);
      }

      return [...prevOpenAlertTypes, id];
    });
  };

  return (
    <div className={classes.studentAlertsSection}>
      {_.map(alerts, alert => {
        const { id, title, alertType } = alert;
        const { icon } = alertType;
        const isOpen = _.includes(openAlerts, id);
        const AlertIcon = getStudentAlertTypeIcon({ iconMetaData: icon });
        const handleToggleClick = getToggleAlertTypeHandler(id);
        const handleToggleKeyDown = e =>
          onEnterOrSpaceKeyDown(e, handleToggleClick);

        return (
          <div key={id} className={classes.alertContainer}>
            <div
              onClick={handleToggleClick}
              onKeyDown={handleToggleKeyDown}
              role="button"
              tabIndex={0}
              aria-label={title}
              className={classes.alertTypeHeader}
            >
              <div className={classes.alertHeaderLeftContainer}>
                <AlertIcon size="xx-small" className={classes.alertIcon} />
                <div className="text-label">{title}</div>
              </div>
              <IconButton
                dsVersion="2.0"
                variant="neutral"
                type="plain"
                size="x-small"
                icon={isOpen ? <ChevronUpOutlined /> : <ChevronDownOutlined />}
                testId={`studentAlert-${id}`}
              />
            </div>
            {isOpen ? <AlertCard alert={alert} showHeader={false} /> : null}
          </div>
        );
      })}
    </div>
  );
};

export default StudentAlertsSection;
